import script from "./CommunityPolicingWebEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommunityPolicingWebEntry.vue?vue&type=script&setup=true&lang=ts"

import "./CommunityPolicingWebEntry.vue?vue&type=style&index=0&id=06a23d0c&lang=scss"

const __exports__ = script;

export default __exports__